import { render, staticRenderFns } from "./AddChecklists.vue?vue&type=template&id=06b5ef9a&scoped=true&"
import script from "./AddChecklists.vue?vue&type=script&lang=js&"
export * from "./AddChecklists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b5ef9a",
  null
  
)

export default component.exports